import React, { useEffect, useRef, useState } from 'react'
import { DownloadImage } from './DownloadImage';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

import feather_upload_cloud from "../../assets/images/feather_upload_cloud.svg";
import Trash from '../../assets/images/gray_delete.svg'; 
import { toast } from 'react-toastify';

const AddAttachment = ({ propData, fClass, sendData }) => {

    // IMAGE UPLOAD START
    const fileInputRef = useRef(null);
    const [isTopDel, setIsTopDel] = useState(false);
    const [files, setFiles] = useState([]);
    const [editFiles, setEditFiles] = useState([]);
    const [base64Files, setBase64Files] = useState([]);

    useEffect(() => {
        if (propData) {
            setFiles(propData)
        }
    }, [])
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);

    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, id, type) => {
        if (isTopDel) {
            setEditFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        } else {
            setFiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
            // base64Files.splice(index, 1);
            setBase64Files((prevBase64Files) => {
                const newBase64Files = [...prevBase64Files];
                newBase64Files.splice(index, 1);

                // Update local storage
                sendData(newBase64Files)
                // setFormData((prevFormData) => {
                //     const newFormData = { ...prevFormData, base64Files: newBase64Files, files: newBase64Files };
                //     return newFormData;
                // });

                return newBase64Files;
            });
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        
        const selectedFiles = Array.from(e.target.files);

        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = base64Files || [];
        const existingFiles = files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const chkDupli = files?.find(f => f.name === file.name)
                if (chkDupli) {
                    toast.warning('Duplicate Image');
                    return;
                }
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    const mergedFiles = [...existingFiles, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    sendData(mergedFiles)
                    // setFormData((prevFormData) => {
                    //     // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                    //     const newFormData = { ...prevFormData, files: mergedFiles };

                    //     return newFormData;
                    // });
                }
            };
            reader.readAsDataURL(file);
        });
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };
    const handleDeleteImage = (index, id, type) => {
        setIsTopDel(true);
        handleDeleteFile(index);
        // setShowConfirmation(true); need to work
    };

    const handleDownload = (imageUrl, imageName) => {
        DownloadImage(imageUrl, imageName)
    }
    // IMAGE UPLOAD END
    return (
        <div className={fClass}>
            <div className="upload-wrapper" onDrop={handleDrop} onDragOver={handleDragOver}>
                <div className='upload-box'>
                    <div className="upload-content text-center">
                        <img src={feather_upload_cloud} alt="upload" className="upld_icon" />

                        <h6 className="upload-title">
                            Select a file or drag and drop here
                        </h6>

                        <p className="upload-subtitle">
                            JPG, PNG or PDF, file size no more than 25MB
                        </p>
                        <Button
                            variant="outline-primary"
                            size="sm"
                            className="upload-btn"
                            onClick={handleBrowseFiles}
                        >
                            SELECT FILE
                        </Button>


                        <input
                            type="file"
                            ref={fileInputRef}
                            hidden
                            accept="image/png,image/jpeg,application/pdf"
                            onChange={handleFileChange}
                            multiple
                        />
                    </div>
                </div>
            </div>
            <div className="remark-files">
                {files?.map((file, index) => {
                    const fileName = file.name;
                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                    const extension = fileName?.split(".").pop();
                    return (
                        <>
                            {/* <div key={index} className='img-thumbnail'> */}
                            <div>
                                <FontAwesomeIcon icon={faDownload} onClick={() => handleDownload(file.file_path, file.file_name)} />
                                {/* {baseName} */}
                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                <img src={Trash} onClick={() => handleDeleteFile(index)} alt="delete_icon" />
                            </div>
                            {/* {["jpeg", "jpg", "png", "webp"].includes(file.name.split(".")[file.name.split(".").length - 1]
                                ) ? (
                                    <>
                                        <img
                                            src={URL.createObjectURL(file)}
                                            alt="Preview"
                                            style={{
                                                maxWidth: "30px",
                                                maxHeight: "30px",
                                                marginRight: "5px",
                                            }}

                                        />
                                        <span>
                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span className="d-flex align-items-center">
                                            <img src={Docmnt} style={{
                                                maxWidth: "30px",
                                                maxHeight: "30px",
                                                marginRight: "5px",
                                            }} />
                                            <span>  {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 10)}... .${extension}`}</span>
                                        </span>
                                    </>
                                )} */}


                            {/* <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button> */}
                            {/* </div> */}
                        </>
                    )
                })}
                {/* <Button variant="">
                    <FontAwesomeIcon icon={faDownload} />
                    Missing Report
                    <img src={delete_icon} alt="delete_icon" />
                </Button>

                <Button variant="">
                    <FontAwesomeIcon icon={faDownload} />
                    Damage Overview Report
                    <img src={delete_icon} alt="delete_icon" />
                </Button> */}
            </div>
        </div>
    )
}

export default AddAttachment